/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import EquipmentIcon from 'icons/EquipmentIcon';

const messages = defineMessages({
  title: {id: 'navigation.equipment'},
});

const EquipmentItem = () => (
  <RouteLinkItem
    iconBefore={EquipmentIcon}
    route="midas/students/equipment"
    title={messages.title}
  />
);

export default EquipmentItem;
